module.exports = __webpack_public_path__ + "static/media/io.a45231d4.svg";